import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const FlightRequestDetails = ({ flightResources }) => {

    return (
        <>
            <Timeline align="alternate">
                {
                    flightResources.map((resource, index) =>
                        <TimelineItem key={index}>
                            <TimelineOppositeContent>
                                <Typography color="textSecondary">
                                    {resource.goingFromDate.substring(0, 10)}
                                </Typography>
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineDot />
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <Paper style={{ padding: `4px` }}>
                                    <Typography variant="button" display="block" gutterBottom>
                                        {resource.goingFromDestinationName}, {resource.goingToDestinationName}
                                    </Typography>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        <b>{resource.flightTypeName ? <>{resource.flightTypeName}<br /></> : ''}</b>
                                        {resource.airlineName ? `${resource.airlineName}, ` : ''}
                                        {resource.flightCabinType1 ? `${resource.flightCabinType1}, ` : ''}
                                        {resource.goingPreferedTime}
                                    </Typography>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        {resource.adultsNumber ? `${resource.adultsNumber} Adults` : ''}
                                        {resource.childrenNumber ? `, ${resource.childrenNumber} Childs` : ''}
                                        {resource.infantsNumber ? `, ${resource.infantsNumber} Infants`: ''}
                                        {resource.adultsNumber === null ? `${resource.goingNooftickets} Tickets` : ''}
                                    </Typography>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        {resource.returnFromDate ? <b>Return {resource.returnFromDate.substring(0, 10)}</b> : ''}
                                    </Typography>
                                </Paper>
                            </TimelineContent>
                        </TimelineItem>
                    )
                }
            </Timeline>
        </>
    )
}

export default FlightRequestDetails;